import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as Fingerprint } from '../../assets/images/svg/fingerprint.svg';
import themeColors from '../../assets/styles/themeColors';

const FingerprintStyled = styled(Fingerprint)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  fill: ${({ color }) => color || themeColors.colorTextPrimary};

  circle {
    fill: ${themeColors.colorBackgroundPrimaryDark};
  }
`;

const FingerprintIcon = (props) => <FingerprintStyled {...props} />;

FingerprintIcon.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

FingerprintIcon.defaultProps = {
  w: '62px',
  h: '62px',
};

export default FingerprintIcon;
